import "./PictoRadio.scss";
import PropTypes from "prop-types";
import RadioFormik from "app/pages/.shared/form/RadioFormik";

const PictoRadio = ({ value, checked, id, name, icon, label, toggle }) => {
	return (
		<div className="picto-radio">
			<RadioFormik name={name} id={id} value={value} checked={checked} toggle={toggle}>
				{icon}
				<div className="picto-radio__label">{label}</div>
			</RadioFormik>
		</div>
	);
};

PictoRadio.propTypes = {
	checked: PropTypes.bool,
	name: PropTypes.string,
	toggle: PropTypes.func,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	id: PropTypes.string.isRequired,
	icon: PropTypes.element,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default PictoRadio;
